import { Component, OnInit } from '@angular/core';
import * as AWS from "aws-sdk";
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/http.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-webinarvideo',
  templateUrl: './webinarvideo.component.html',
  styleUrls: ['./webinarvideo.component.css']
})
export class WebinarvideoComponent implements OnInit {
  s3: any;
  videoUrl!: SafeUrl;
  constructor(private httpService: HttpService, private domSanitizer: DomSanitizer) {

    let AKey;
    let SKey;
    let url = environment.API_URL + "fetchbucketcred"
    this.httpService.getAPI(url).then((resp: any) => {
      let decRes = this.httpService.decryptText(resp, HttpService.SECRET_KEY);
      let decMsg = JSON.parse(decRes);

      AKey = decMsg?.lkpList[0].lkpvalue;
      SKey = decMsg?.lkpList[1].lkpvalue;
      AWS.config.update({
        accessKeyId: AKey,
        secretAccessKey: SKey,
        region: "ap-south-1",
      });
      this.s3 = new AWS.S3();

      setTimeout(() => {
        let logo = "video/Webinar_Video_Nov.mp4";

        const url = this.s3.getSignedUrl("getObject", {
          Bucket: environment.Bucket,
          Key: logo,
          Expires: 60,
        });
        console.log(url);

        this.videoUrl = this.domSanitizer.bypassSecurityTrustUrl(url);
      }, 900);
    });
  }

  ngOnInit(): void {
  }

}
